








































































    import {Component, Prop, Watch, Mixins } from "vue-property-decorator";
    import {Participant as ParticipantModel} from "../../api/models/meetings/Participant";
    import Description from "../common/Description.vue";
    import {ParticipantStatuses} from "../../api/enums/Meetings/ParticipantStatuses";
    import {MeetingDataHelper} from "./helper/MeetingDataHelper";

    import {EventBus} from '@common/EventBus';

    import {Meeting} from "@api/models/meetings/Meeting";
    import {ParticipantStatusChange} from "../../types/ParticipantStatusChange";
    import {IsFromMy} from "@mixins/isFromMy";
    import {Modal} from "@common/Modal";

    import {UserRepository} from "@api/repositories/UserRepository";
    import { MeetingPanelTabs } from "@mixins/models/MeetingPanelTabs"
    import { BackgroundViewHelper } from "@service/components/background-view/BackgroundViewHelper/BackgroundViewHelper"
    import { BackgroundViewName } from "@service/components/background-view/types/BackgroundViewName"

    import ObjectLayout, { SwitchersTypes } from "@service/layouts/ObjectViewLayout.vue";
    import WebConference from "@share/web-conferences/WebConference.vue";
    import ComingSoon from "@share/session/components/coming-soon/ComingSoon.vue";
    import Comments from '../comments/components/Comments.vue';

    import { MiniPlayerParams } from "@service/store/types/MiniPlayerState";
    import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
    import { dateInOriginalOffset } from "@common/dateTimeHelper";
    import AnalyticsMixin from "@mixins/AnalyticsMixin";
    import { detectMob } from "@common/mobileHelper";
	import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
    import { isRouteMeetings } from "@service/router/helpers/commonRoutesHelper";

    import ObjectSidebar from "@share/object-sidebar/ObjectSidebar.vue";
    import PeopleManagement, { PeopleManagementParams } from "@share/web-conferences/components/people/PeopleManagement.vue";

    @Component({
        name: 'MeetingLive',
        components: {
          ComingSoon, ObjectSidebar, PeopleManagement,
          WebConference, ObjectLayout, Description, Comments },
    })
    export default class MeetingLive extends Mixins(IsFromMy, AnalyticsMixin) {
        @Prop({default: true}) showMessageBtn: boolean;
        @Prop({required: true}) meetingId: string;
        // http://localhost:8080/app/meetings/fe868448-d001-45a6-b316-274115b87a15/public?sdata=1IGf3TIUOI%2bwxrOBu%2fX3s1EbRdWa2ztG6yR667zNKZU3q0U2jDsagk6qGH0ZLRzyNdjktzibMF2gGdr8E4aNTJUkLc6J4Pi5F3Sh4aHeE6I%3d&skey=0Va6o1gr1JLnv7uQ
        dataHelper: MeetingDataHelper | null = null;
        isLoading = true;
        currentPanelTab: MeetingPanelTabs = MeetingPanelTabs.chat;
        userRepository: UserRepository | null = null;
        MeetingPanelTabs = MeetingPanelTabs;

        showComingsoon = false;
        commentsMustShown = false;

        joinedSuccessfully: boolean | null = null;

        private setVideoController() {

            if(this.meeting && this.isLive) {
                const params: MiniPlayerParams = {
                    object: this.meeting,
                    returnRouteName: RouteNamesEnum.viewMeeting || "Home"
                }

                this.$emit('updateMiniPlayerParams', params);
            }
        }

        get onlineUsersCounterId() {
            return 'meetings/' + this.dataHelper?.meeting.id;
        }

        private get peopleComponentParams(): PeopleManagementParams {
            return { onlyOnline: true, initOnMount: !this.isOwner }
        }

        private get userId() {
            return this.$store.state.session.userId;
        }

        get isOwner() {
            return this.meeting?.ownerId === this.userId;
        }

        private get meeting() {
            return this.dataHelper?.meeting;
        }

        private get currentUserParticipant(): ParticipantModel | null {
            return this.dataHelper?.currentUserParticipant || null;
        }

        private get isNow() {
            if (this.meeting) {
                return this.meeting?.isNow() || false;
            }
            return false;
        }

        private get showConnect() {
            return this.isNow && [ParticipantStatuses.accepted.toString(), ParticipantStatuses.pending.toString()]
                            .indexOf((this.currentUserParticipant?.status as string || '').toLowerCase()) > -1;
        }

        private get showChatTab() {
            return this.currentPanelTab === MeetingPanelTabs.chat;
        }

        private get webConference() {
          // return this.dataHelper?.webinarInfo?.onlineProvider == OnlineProvider.webConference;
            return [OnlineProvider.webConference, OnlineProvider.agora, OnlineProvider.liveKit].indexOf(this.dataHelper?.webinarInfo?.onlineProvider as any) >= 0;
        }

        private get isLiveClean() {
            return this.showConnect || this.webConference;
        }

        private get isLive() {
            if (this.isLoading) {return false;}
            return this.isLiveClean;
        }

        private get broadcastQue() {
            return this.$store.state.backgroundView.broadcastQue;
        }

        private get isPublic() {
            return this.$route.name == RouteNamesEnum.viewMeetingPublic;
        }

        private get isCreator()
        {
            return this.dataHelper?.meeting.ownerId == this.userId;
        }

        private get isRecording() {
            return this.$route.name == RouteNamesEnum.viewMeetingPublicRecording;
        }

        /**
         * calling every second for catch moment of 15 min before start meeting
         */
        private async update() {
            if(this.meeting?.isNow()) {
                this.showComingsoon = false;

                // небольшая задержка из-за того что данные приходят в зависимости от времени
                setTimeout(() => {
                   try {
                       this.dataHelper?.fetchWebinarInfo();
                   }
                   catch(e) {
                       if (e.name === 'BackendUnexpectedError') {
                            this.showRetryDialog();
                        } else {
                            this.$store.dispatch('reportException', e, {root: true});
                        }
                   }
                }, 1500);
            }
        }

        private selectProfile(item: any) {
            this.$emit('showProfile', item.userId);
        }

        async mounted() {
            this.dataHelper = new MeetingDataHelper(this.userId, this.$repositories);
            await this.initData();
            EventBus.$on('eventSaved', this.updateMeeting);
            EventBus.$on('participantStatusChanged', this.participantStatusChanged);
            EventBus.$on('program/removeMeetingById', this.removeMeetingById);
            this.setIsFromMy();


            window.addEventListener("resize", this.resizeHandler);

            this.updateCommetsVisibility();
        }

        onSidebarVisibilityChange({ type, state }: { type: SwitchersTypes; state: boolean }) {
            if(type === "mobile" && !state) {
                this.commentsMustShown = true;
            }
        }

        joiningHandler(joined: boolean) {
            this.joinedSuccessfully = joined;
        }

        resizeHandler() {
            this.updateCommetsVisibility();
        }

        updateCommetsVisibility() {
            this.commentsMustShown = !detectMob();
        }

        private async initData() {
            this.isLoading = true;
            try {
                await this.dataHelper?.setMeeting(this.meetingId);

                /* checking another broadcast is exist */
                await this.checkBroadcast(this.isNow || !this.showComingsoon || Boolean(this.meeting?.isEnded()));

                if ((this.isNow || !this.showComingsoon) && this.currentUserParticipant?.status?.toLowerCase() != ParticipantStatuses.accepted) {
                    await this.changeStatus(ParticipantStatuses.accepted);
                    await this.dataHelper?.fetchWebinarInfo();
                }

                this.isLoading = false;
                this.loaded();
                this.sendAnalytics(this.dataHelper?.meeting);
                this.$store.dispatch("setPageTitle", this.dataHelper?.meeting?.title);

                if(!this.isNow && !this.meeting?.isEnded()) {
                    this.showComingsoon = true;
                }
            } catch (e) {
                if (e.name === 'BackendUnexpectedError') {
                    this.showRetryDialog();
                } else {
                    this.isLoading = false;
                    this.$store.dispatch('reportException', e, {root: true});
                }
                this.isLoading = false;
            }
        }

        private sendAnalytics(meeting?: Meeting) {
            if(meeting && meeting.beginAt) {
                const originalDate = dateInOriginalOffset(meeting.beginAt, this.$store.state.timeZoneOffset);
                const timeAndTitle = `${originalDate.toFormat('dd.MM.yyyy H:mm')} ${meeting.title}`;
                this.sendScreenView(`Meeting - ${timeAndTitle}`, meeting.id, "meetings");
            }
        }

        @Watch('meetingId')
        async onMeetingIdChanged() {
            await this.initData();
        }

        @Watch('routeName')
        watchRouteName() {
            if(isRouteMeetings(this.$route.name || '')) {
                this.sendAnalytics(this.dataHelper?.meeting);
            }
        }

        private updateMeeting(meeting: Meeting) {
            this.dataHelper?.updateMeeting(meeting);
        }

        private loaded() {
            this.$emit('loaded', {
                element: this.dataHelper?.meeting,
                isLive: this.isLive
            })
        }

        private async checkBroadcast(isNow: boolean) {
            if(isNow) {
                const broadcastIsBusy = BackgroundViewHelper.checkBroadcastIsBusy(this.broadcastQue);

                if(broadcastIsBusy) {

                    const confirmed = await BackgroundViewHelper.doConfirmModal();
                    if(confirmed && confirmed !== "close") {
                        this.$emit('liveConfirmed', true);
                    }
                    else {
                        if(BackgroundViewHelper.getActiveBroadcastView(this.broadcastQue) === BackgroundViewName.meeting) {
                            this.$store.dispatch("backgroundView/setOffline", BackgroundViewName.meeting);
                        }
                        else {
                            this.$emit('liveConfirmed', false);
                        }

                        this.$router.back();
                    }
                }
                else {
                    this.$emit('liveConfirmed', true);
                }
            }
        }

        private async changeStatus(status: ParticipantStatuses) {
            if (this.currentUserParticipant) {
                this.$store.dispatch('showSpinner');
                const previousStatus = this.currentUserParticipant.status;
                try {
                    await this.dataHelper?.changeStatus(status);
                }
                catch (e) {
                    this.$store.dispatch('reportException', e, {root: true});
                }
                this.$store.dispatch('hideSpinner');
                EventBus.$emit('participantStatusChanged', {
                    participantId: this.currentUserParticipant.id,
                    meetingId: this.meeting?.id,
                    status: status,
                    previousStatus: previousStatus,
                    beginAt: this.meeting?.beginAt
                } as ParticipantStatusChange)
            }
        }

        private close() {
            this.$emit('closed');
            this.$emit('liveConfirmed', false);
        }

        private participantStatusChanged(data: ParticipantStatusChange) {
            if (data.participantId == this.currentUserParticipant?.id) {
                this.dataHelper?.updateStatus(data.status);

                if(data.status === ParticipantStatuses.declined) {
                    this.close();
                }
            }
        }

        private removeMeetingById(meetingId: string) {
            if (this.meeting?.id == meetingId) {
                this.$set(this.dataHelper?.meeting as Meeting, 'isDeleted', true);
            }
        }

        destroyed() {
            window.removeEventListener("resize", this.resizeHandler)
            EventBus.$off('eventSaved', this.updateMeeting);
            EventBus.$off('participantStatusChanged', this.participantStatusChanged);
            EventBus.$off('program/removeMeetingById', this.removeMeetingById);
        }

        private async showRetryDialog() {
            const modal = new Modal({
                title: this.$t('common.liveConnectErrorConfirmTitle').toString(),
                contentText: this.$t('common.liveConnectErrorConfirmText').toString(),
                buttons: [
                    {
                        text: this.$t('common.liveConnectErrorConfirmRetryButton').toString(),
                        class: 'is-green',
                        returnValue: true
                    },
                ]
            });

            const confirmResult = await modal.showConfirm();

            if (confirmResult == 'close') {
                this.isLoading = false;
                return;
            }

            if (confirmResult === true) {
                this.initData();
            }
        }

        private onNewComment() {
            if (this.dataHelper) {
                this.dataHelper.commentsCount++;
            }
        }
    }
